import { render, staticRenderFns } from "./NewPasswordPage.vue?vue&type=template&id=b1da5d64&scoped=true"
import script from "./NewPasswordPage.vue?vue&type=script&lang=js"
export * from "./NewPasswordPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1da5d64",
  null
  
)

export default component.exports